<div class="row m-0">
  <div class="col-12 page-heading-wrapper">
    <gb-ui-page-heading [titleText]="this.selectedDepartment?.extra?.review_page_title" [displayBacklink]="true"
      [backLinkText]="'COMMON.BACK' | translate" (back)="routerGoBack()"></gb-ui-page-heading>
  </div>
</div>
<div class="govuk-width-container">
  <div class="row">
    <div class="col-sm-12">
      <ui-stepper [steps]="steps"></ui-stepper>
    </div>
  </div>
  <div class="govuk-grid-row" id="main-content" tabindex="-1">
    <div class="govuk-grid-column-full">
      <h1>{{datastoreService?.pageContent?.review_page_subtitle}}</h1>
      <p [innerHTML]="datastoreService?.pageContent?.review_page_subtitle_body"></p>
      <!--
        The group citizenship ceremony can fill up between choosing a slot and reaching
        this page. That is a fact with a way out of it, not a failure, so it is said here
        rather than through the alert summary, which is headed "There is a problem" and
        offers the customer nothing to do about it.
      -->
      <div *ngIf="citizenshipCapacityFull" id="citizenship-capacity-banner" tabindex="-1"
        class="govuk-notification-banner" role="region"
        aria-labelledby="citizenship-capacity-banner-title" data-module="govuk-notification-banner">
        <div class="govuk-notification-banner__header">
          <h2 class="govuk-notification-banner__title" id="citizenship-capacity-banner-title">
            {{ 'COMMON.CITIZENSHIP_CAPACITY_TITLE' | translate }}
          </h2>
        </div>
        <div class="govuk-notification-banner__content">
          <p class="govuk-notification-banner__heading govuk-notification-banner__heading--inverse">
            {{ 'COMMON.CITIZENSHIP_CAPACITY_HEADING' | translate }}
          </p>
          <ul class="govuk-list govuk-list--bullet">
            <li>
              {{ 'COMMON.CITIZENSHIP_CAPACITY_PLACES_LEFT' | translate: { spaces: citizenshipCapacitySpaces } }}
            </li>
            <li>
              {{ 'COMMON.CITIZENSHIP_CAPACITY_PLACES_NEEDED' | translate: { places: citizenshipCapacityRequired } }}
            </li>
          </ul>
          <p class="govuk-body">
            {{ 'COMMON.CITIZENSHIP_CAPACITY_NOT_CHARGED' | translate }}
          </p>
          <button type="button" class="govuk-button govuk-button--inverse" data-module="govuk-button"
            (click)="chooseAnotherDateAndTime()">
            <span style="color: #fff;">{{ 'COMMON.CITIZENSHIP_CAPACITY_CHOOSE_ANOTHER' | translate }}</span>
          </button>
        </div>
      </div>


      @if (agentMode) {
      <button type="button" class="govuk-button govuk-button--inverse heading-button" data-module="govuk-button"
        (click)="datastoreService?.agentRestart()">
        Agent Restart
      </button>
      }

      <hr />

      <div class="govuk-summary-card">
        <div class="govuk-summary-card__title-wrapper">
          <h2 class="govuk-summary-card__title" aria-label="Booking details">
            {{ 'COMMON.PATIENT_DETAILS' | translate }}
          </h2>
        </div>
        <div class="govuk-summary-card__content">
          <dl class="govuk-summary-list">
            <div class="govuk-summary-list__row">
              <dt class="govuk-summary-list__key" aria-label="Name">
                {{ 'COMMON.NAME' | translate }}
              </dt>
              <dd class="govuk-summary-list__value body-lg">
                {{ client?.first_name }} {{ client?.last_name }}
              </dd>
            </div>

            <div class="govuk-summary-list__row">
              <dt class="govuk-summary-list__key" aria-label="Email address">
                {{ 'COMMON.EMAIL_ADDRESS' | translate }}
              </dt>
              <dd class="govuk-summary-list__value body-lg">
                {{ client?.email_address }}
              </dd>
            </div>

            <div class="govuk-summary-list__row" *ngIf="selectedSlot?.mobile_number">
              <dt class="govuk-summary-list__key" aria-label="Mobile number">
                {{ 'COMMON.MOBILE_NUMBER' | translate }}
              </dt>
              <dd class="govuk-summary-list__value body-lg">
                {{ selectedSlot?.mobile_number }}
              </dd>
            </div>

            <div class="govuk-summary-list__row" *ngIf="client?.postcode">
              <dt class="govuk-summary-list__key" aria-label="Postcode">
                {{ 'COMMON.POSTNAME' | translate }}
              </dt>
              <dd class="govuk-summary-list__value body-lg">
                {{ selectedSlot?.postcode }}
              </dd>
            </div>
          </dl>
        </div>
      </div>

      <div class="govuk-grid-row">
        <div class="govuk-grid-column-full">
          <div class="govuk-summary-card">
            <div class="govuk-summary-card__title-wrapper">
              <h2 class="govuk-summary-card__title" aria-label="Service">
                {{ 'COMMON.SERVICE' | translate }}
              </h2>
            </div>
            <div class="govuk-summary-card__content">
              <dl class="govuk-summary-list">
                <div class="govuk-summary-list__row">
                  <dt class="govuk-summary-list__key" aria-label="Service Name">
                    {{ 'COMMON.SERVICE_NAME' | translate }}
                  </dt>
                  <dd class="govuk-summary-list__value body-lg">
                    {{ selectedService?.name }}
                  </dd>
                </div>
                <div class="govuk-summary-list__row">
                  <dt class="govuk-summary-list__key" aria-label="Duration">
                    {{ 'COMMON.DURATION' | translate }}
                  </dt>
                  <dd class="govuk-summary-list__value body-lg">
                    {{ selectedService?.calculated_duration }} minutes
                  </dd>
                </div>
              </dl>
            </div>

            <div class="govuk-summary-card__content">
              <dl class="govuk-summary-list">
                <div class="govuk-summary-list__row">
                  <dt class="govuk-summary-list__key" aria-label="Date">Location</dt>
                  <dd *ngIf="!citizenshipJourney" class="govuk-summary-list__value body-lg">
                    {{ selectedLocation?.name }}
                  </dd>

                  <dd *ngIf="citizenshipJourney" class="govuk-summary-list__value body-lg">
                    Westminster Register Office
                  </dd>

                </div>

                <div class="govuk-summary-list__row">
                  <dt class="govuk-summary-list__key" aria-label="Time">Address</dt>

                  <ng-container *ngIf="!citizenshipJourney">
                    <dd class="govuk-summary-list__value body-lg">
                      <ng-container *ngIf="address?.address1">
                        {{ address.address1 }}
                      </ng-container>

                      <ng-container *ngIf="address?.address2">
                        , {{ address.address2 }}
                      </ng-container>

                      <ng-container *ngIf="address?.address4">
                        , {{ address.address4 }}
                      </ng-container>

                      <ng-container *ngIf="address?.address5">
                        , {{ address.address5 }}
                      </ng-container>

                      <ng-container *ngIf="address?.postcode">
                        , {{ address.postcode }}
                      </ng-container>

                    </dd>
                  </ng-container>

                  <!-- <ng-container *ngIf="citizenshipJourney">
                    <dd class="govuk-summary-list__value body-lg">
                      The Old Marylebone Town Hall, 97-113 Marylebone Rd, London, NW1 5PT
                    </dd>
                  </ng-container> -->

                </div>
              </dl>
            </div>

            <div class="govuk-summary-card__content">
              <dl class="govuk-summary-list">
                <div class="govuk-summary-list__row">
                  <dt class="govuk-summary-list__key" aria-label="Date">
                    {{ 'COMMON.DATE' | translate }}
                  </dt>
                  <dd class="govuk-summary-list__value body-lg">
                    {{
                    selectedSlot?.start
                    | date
                    : 'EEEE d MMMM yyyy'
                    : ''
                    : translateService.currentLang
                    }}
                  </dd>
                </div>

                <div class="govuk-summary-list__row">
                  <dt class="govuk-summary-list__key" aria-label="Time">
                    {{ 'COMMON.TIME' | translate }}
                  </dt>
                  <dd class="govuk-summary-list__value body-lg">
                    {{ selectedSlot?.displayTime }}
                  </dd>
                </div>
              </dl>
            </div>
          </div>

          <div class="govuk-summary-card">
            <div class="govuk-summary-card__title-wrapper">
              <h2 class="govuk-summary-card__title" aria-label="Booking details">
                {{ 'COMMON.BOOKING_QUESTIONS' | translate }}
              </h2>
            </div>
            <div class="govuk-summary-card__content">
              <dl class="govuk-summary-list" *ngFor="let detail of bookingSummaryData">
                <div class="govuk-summary-list__row">
                  <dt class="govuk-summary-list__key">
                    {{ detail.name | translateSplit }}
                  </dt>
                  <dd class="govuk-summary-list__value body-lg">
                    {{ formatQuestion(detail.answer) }}
                  </dd>
                </div>
              </dl>
            </div>
          </div>

          <app-cost-breakdown *ngIf="selectedDepartment" [company]="selectedDepartment"
            [costBreakDown]="costBreakDown"></app-cost-breakdown>

          <!-- <ng-container *ngIf="adminJourney">
                            <h2 aria-label="Payment details">
                  {{ 'COMMON.ADMIN_BOOKING_DETAILS' | translate }}
                </h2>
            <div class="govuk-summary-card">
              <div class="govuk-summary-card__title-wrapper">
              </div>
              <form [formGroup]="adminForm" class="govuk-summary-card__content">
                <div class="govuk-form-group" [ngClass]="{
                'govuk-form-group--error':
                  form.amount.errors?.required === true && adminFormSubmitted
              }">
                  <h1 class="govuk-label-wrapper">
                    <label class="govuk-label govuk-label--s" for="amount">
                      <span aria-hidden="true" class="form-field-required-marker">
                        *</span>Payment amount
                    </label>
                  </h1>
                  <p *ngIf="form.amount?.errors && adminFormSubmitted" id="event-name-error"
                    class="govuk-error-message">
                    <span class="govuk-visually-hidden">Error:</span>
                    {{
                    'COMMON.IS_REQUIRED'
                    | translate : { value: 'COMMON.ADMIN_AMOUNT' | translate }
                    }}
                  </p>
                  <div class="govuk-input__wrapper">
                    <div class="govuk-input__prefix" aria-hidden="true">£</div>
                    <input class="govuk-input" id="amount" name="amount" type="text" formControlName="amount" />
                  </div>
                </div>
                <div class="govuk-form-group" [ngClass]="{
                'govuk-form-group--error':
                  form.reference.errors?.required === true && adminFormSubmitted
              }">
                  <h1 class="govuk-label-wrapper">
                    <label class="govuk-label govuk-label--s" for="reference">
                      <span aria-hidden="true" class="form-field-required-marker">
                        *</span>Transaction reference generated
                    </label>
                  </h1>
                  <p *ngIf="form.reference?.errors && adminFormSubmitted" id="event-name-error"
                    class="govuk-error-message">
                    <span class="govuk-visually-hidden">Error:</span>
                    {{
                    'COMMON.IS_REQUIRED'
                    | translate : { value: 'COMMON.ADMIN_REF' | translate }
                    }}
                  </p>
                  <input class="govuk-input" id="reference" name="reference" type="text" formControlName="reference" />
                </div>

                <div class="govuk-form-group" [ngClass]="{
                'govuk-form-group--error':
                  form.amount.errors?.required === true && adminFormSubmitted
              }">
                  <h1 class="govuk-label-wrapper">
                    <label class="govuk-label govuk-label--s" for="amount">
                      <span aria-hidden="true" class="form-field-required-marker">
                        *</span>Type of payment
                    </label>
                  </h1>
                  <p *ngIf="form.reference?.errors && adminFormSubmitted" id="event-name-error"
                    class="govuk-error-message">
                    <span class="govuk-visually-hidden">Error:</span>
                    {{
                    'COMMON.IS_REQUIRED'
                    | translate : { value: 'COMMON.ADMIN_NOTE' | translate }
                    }}
                  </p>
                  <select class="govuk-select" formControlName="note">
                    <option></option>
                    <option value="Appointment Fee Only">
                      Appointment Fee Only
                    </option>
                    <option value="Appointment Fee & Certificates">
                      Appointment Fee & Certificates
                    </option>
                  </select>
                </div>
               
              </form>
            </div>
          </ng-container> -->

          <fieldset>

            <!-- <legend class="govuk-visually-hidden">
              Survey consent
            </legend>

            <div>
              <p class="govuk-body" [innerHTML]="selectedDepartment?.extra?.survey_consent">
              </p>

              <div class="govuk-checkboxes" data-module="govuk-checkboxes">
                <div class="govuk-checkboxes__item">
                  <input aria-required="true" [(ngModel)]="agreeDataPolicy" class="govuk-checkboxes__input"
                    id="dataPolicy" name="dataPolicy" type="checkbox" />

                  <label *ngIf="adminJourney" class="govuk-label govuk-checkboxes__label" for="dataPolicy">
                    {{ 'COMMON.SURVEY_CONSENT_ADMIN' | translate }}
                  </label>

                  <label *ngIf="!adminJourney" class="govuk-label govuk-checkboxes__label" for="dataPolicy">
                    {{ 'COMMON.SURVEY_CONSENT' | translate }}
                  </label>
                </div>
              </div>
              <br />
            </div> -->

            <div>
              <!--               <p class="govuk-body" *ngIf="adminJourney">
                Please confirm that you have advised the customer of their ceremony fees
                and have checked the payment information is correct.
              </p> -->
              <p class="govuk-hint">
                Fields marked with an asterisk (<span aria-hidden="true">*</span>) are required.
                <span class="govuk-visually-hidden">All fields marked with an asterisk are required.</span>
              </p>
              <p class="govuk-body" *ngIf="!adminJourney"
                [innerHTML]="selectedService?.extra?.terms_and_conditions_service" (click)="linkClicked($event)"
                (keypress)="linkClicked($event)">
              </p>

              <div class="govuk-checkboxes" data-module="govuk-checkboxes">
                <div class="govuk-checkboxes__item">
                  <input aria-required="true" [(ngModel)]="confirmContinue" class="govuk-checkboxes__input"
                    id="mustConfirm" name="mustConfirm" type="checkbox" />

                  <label *ngIf="adminJourney" class="govuk-label govuk-checkboxes__label" for="mustConfirm">
                    The customer has confirmed the booking information is correct and would like to proceed with the
                    booking.
                  </label>

                  <label *ngIf="!adminJourney" class="govuk-label govuk-checkboxes__label" for="mustConfirm">
                    <span aria-hidden="true">*</span> I confirm and understand the above
                  </label>

                </div>
              </div>

              <!--
                Proof of identity (Gloucestershire legislative changes). Birth registration (48346)
                and birth declaration (48356) only, matched on the global service id so every
                location's copy of the service is covered. Template-only: the checkbox is a
                standalone ngModel read through its template reference, and it stays in the DOM
                (hidden) on other services so the reference is in scope for the buttons below.
              -->
              @let requiresProofOfIdentity = ['48346', '48356'].includes('' + selectedService?.global_id);
              <div id="proof-of-identity" [hidden]="!requiresProofOfIdentity">
                <br />
                <h2>Legal Information</h2>
                <p class="govuk-body">
                  Proof of identity is essential for each informant for a birth registration. The list of acceptable
                  identity documents is available at
                  <a class="govuk-link" href="https://www.gov.uk/register-birth" target="_blank"
                    rel="noopener noreferrer">Register a birth: Overview - GOV.UK</a>
                </p>

                <div class="govuk-checkboxes" data-module="govuk-checkboxes">
                  <div class="govuk-checkboxes__item">
                    <input aria-required="true" ngModel #proofOfIdentityConfirm="ngModel" class="govuk-checkboxes__input"
                      id="proofOfIdentityConfirm" name="proofOfIdentityConfirm" type="checkbox" />

                    <label class="govuk-label govuk-checkboxes__label" for="proofOfIdentityConfirm">
                      <span aria-hidden="true">*</span> I understand what identity documents I need to provide
                    </label>
                  </div>
                </div>
              </div>
              @let proofOfIdentityOutstanding = requiresProofOfIdentity && !proofOfIdentityConfirm.value;
              <br />
              <p class="govuk-body" [innerHTML]="selectedDepartment?.extra?.summary_guidance">
              </p>
              <br />
            </div>

          </fieldset>

          <div class="row pb-4">
            <div class="col-sm-12 btn-bar">

              <ng-container *ngIf="!adminJourney">
                <button *ngIf="!checkoutFailed" type="submit" class="govuk-button govuk-button--inverse" [disabled]="!confirmContinue || proofOfIdentityOutstanding || checkoutStarted"
                  (click)="startCheckout(false)">
                  <span *ngIf="!checkoutStarted">{{ 'COMMON.NEXT' | translate }}</span>
                  <span *ngIf="checkoutStarted">{{ 'COMMON.LOADING' | translate }}</span>
                </button>
                <button class="govuk-button govuk-button--inverse" *ngIf="checkoutFailed"
                  (click)="restartJourney()">
                  {{ 'COMMON.RESTART' | translate }}
                </button>
              </ng-container>

              <ng-container *ngIf="adminJourney && datastoreService.totalCost === 0">
                <button type="submit" class="govuk-button govuk-button--inverse" [disabled]="!confirmContinue || proofOfIdentityOutstanding"
                  (click)="startCheckout(false)">
                  {{ 'COMMON.NEXT' | translate }}
                </button>
              </ng-container>

              <ng-container *ngIf="adminJourney && datastoreService.totalCost > 0">
                <button type="submit" class="govuk-button govuk-button--inverse" style="margin-left: 0px;"
                  [disabled]="!confirmContinue || proofOfIdentityOutstanding" (click)="startCheckout(true)">
                  {{ 'COMMON.ARP_PAYMENT' | translate }}
                </button>
              </ng-container>

            </div>
          </div>
        </div>
      </div>
    </div>
